const PersonaFitRoles = {
    ToBe: {
        TO_BE_GO_GETTER: 'zij-1aanpa',
        TO_BE_CONTROLLER: 'zij-2contr',
        TO_BE_INNOVATOR: 'zij-3innov',
        TO_BE_EXPERT: 'zij-4exper',
        TO_BE_COORDINATOR: 'zij-5coord',
        TO_BE_INSPIRATOR: 'zij-6inspi',
        TO_BE_CONNECTOR: 'zij-7verbi',
        TO_BE_ENTREPRENEUR: 'zij-8onder'
    },
    ToWant: {
        TO_WANT_GO_GETTER: 'wil-1aanpa',
        TO_WANT_CONTROLLER: 'wil-2contr',
        TO_WANT_INNOVATOR: 'wil-3innov',
        TO_WANT_EXPERT: 'wil-4exper',
        TO_WANT_COORDINATOR: 'wil-5coord',
        TO_WANT_INSPIRATOR: 'wil-6inspi',
        TO_WANT_CONNECTOR: 'wil-7verbi',
        TO_WANT_ENTREPRENEUR: 'wil-8onder'
    }
};

export default PersonaFitRoles;
